import { render, staticRenderFns } from "./ElectronicMaterial.vue?vue&type=template&id=18555f81&scoped=true"
import script from "./ElectronicMaterial.vue?vue&type=script&lang=js"
export * from "./ElectronicMaterial.vue?vue&type=script&lang=js"
import style0 from "./ElectronicMaterial.vue?vue&type=style&index=0&id=18555f81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18555f81",
  null
  
)

export default component.exports